/* eslint-disable react-hooks/rules-of-hooks */
"use client";
import { useState, useEffect } from "react";
import { DialogTitle, DialogContent } from "@mui/material";
import UKDialog from "@/components/UKDialog";
import { KlranaDialogWrapper } from "@/styles/product";
import { useTranslation } from "@/i18n/client";

type Props = {
  open: boolean;
  content: string;
  closeFn: any;
};

const DialogStyle = {
  "& .MuiDialog-paper": {
    width: "520px",
    margin: "0",
    borderRadius: "12px",
  },
  "& .MuiDialogTitle-root": {
    fontSize: "16px",
    fontWeight: "bold",
    lineHeight: "20px",
    padding: "20px 24px 12px 24px",
  },
};

const ContentStyle = {
  display: "flex",
  flexDirection: "column",
  padding: "0px 24px 60px 24px",
};

export default function KlranaDialog({ open, content, closeFn }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const closeHandler = () => {
    setIsOpen(false);
    closeFn && closeFn();
  };

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <UKDialog open={isOpen} onClose={closeHandler} showCloseBtn={true} sx={DialogStyle}>
      <DialogTitle>{t("dp.klarnaTitle")}</DialogTitle>
      <DialogContent sx={ContentStyle}>
        <KlranaDialogWrapper>
          <div className="klrana-dialog-content" dangerouslySetInnerHTML={{ __html: content }}></div>
          <div className="klrana-dialog-btn" onClick={closeHandler}>
            {t("common.btnText.ok")}
          </div>
        </KlranaDialogWrapper>
      </DialogContent>
    </UKDialog>
  );
}
